import { Articles } from 'components/blog/Articles';
import { BlogBanner } from 'components/blog/BlogBanner';
import { LatestArticles } from 'components/blog/LatestArticles';
import { Section } from 'components/shared/Section';

const { BlogTheme } = require('components/shared/BlogTheme');

const Blog = () => {
  return (
    <BlogTheme>
      <BlogBanner />

      <Section>
        <LatestArticles />
      </Section>

      <Articles />

      <Section>{/* <LatestArticles /> */}</Section>
    </BlogTheme>
  );
};

export default Blog;
